/* @flow */
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import pdpModelMapper from '@ccxi/ccxi-apps/src/utils/modelMapper/appModelMapper/pdpModelMapper';

class PDPModelMapper {
	/**
	 * toPDPModel function
	 * Map inApp/parsed Contentful data to PDPModel
	 * @param {contentfulPDPItems, controllerData, eventHandlerCallback}
	 * @return {object}
	 */
	toPDPModel = (contentfulPDPItems: Object, controllerData: Object, eventHandlerCallback: Function) => {
		const bannerConfig = {
			supportedVideoFormats: ['mp4'],
			supportedDomains: ['adobe.com']
		};
		return pdpModelMapper.toPDPModel({
			app: controllerData.appObject,
			bannerConfig,
			actionHandlerCallback: eventHandlerCallback,
			contentfulData: contentfulPDPItems,
			actionList: controllerData.applicableActionList
		});
	}
}

export default new PDPModelMapper();
